import store from "../index";

const state = () => ({
  userStats: {},
  usersTable: [{}],
  chartData: {},
  schemeVisitsData: [],
  siteVisitsData: [],
  newsVisitsData: [],
  chartDataLabels: [],
});

const mutations = {
  updateGeneralUsersStatsFrontOffice(state, val) {
    state.userStats = {
      totalActiveUsersCount: val.totalActiveUsersCount,
      usersWithoutNewsletterCount: val.usersWithoutNewsletterCount,
      usersWithVisitInLastMonthCount: val.usersWithVisitInLastMonthCount,
      usersWithoutProfileCount: val.usersWithoutProfileCount,
    };
  },
  updateTableStats(state, val) {
    state.usersTable = val;
  },

  updateGeneralStatsFront(state, val) {
    state.schemeVisitsData = [];
    state.newsVisitsData = [];
    state.siteVisitsData = [];

    store.commit("userStats/updateDataSets", val);
    state.chartDataLabels = [];

    for (let i = 0; i < val.siteVisits.length; i++) {
      state.chartDataLabels.push(
        val.siteVisits[i].monthName + " " + val.siteVisits[i].year
      );
    }

    state.chartData = {
      labels: state.chartDataLabels,

      datasets: [
        {
          label: "Aantal bezoeken",
          backgroundColor: "#FF5B33",
          data: state.siteVisitsData,
          color: "#FF5B33",
          borderColor: "#FF5B33",
        },
        {
          label: "Regelingen bekeken",
          backgroundColor: "#0a108f",
          data: state.schemeVisitsData,
          borderColor: "#0a108f",
          color: "#0a108f",
        },
        {
          label: "Nieuwsitems bekeken",
          backgroundColor: "#1299d7",
          data: state.newsVisitsData,
          borderColor: "#1299d7",
          color: "#1299d7",
        },
      ],
    };
  },

  updateDataSets(state, data) {
    for (let i = 0; i < data.schemeVisits.length; i++) {
      state.schemeVisitsData.push(data.schemeVisits[i].count);
    }
    for (let i = 0; i < data.newsVisits.length; i++) {
      state.newsVisitsData.push(data.newsVisits[i].count);
    }
    for (let i = 0; i < data.siteVisits.length; i++) {
      state.siteVisitsData.push(data.siteVisits[i].count);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
